import React, { Component } from "react";

import DropdownSelect from "../../../components/dropdown/Dropdown";
import DateInput from "../../../components/inputs/DateInput";
import ValidationText from "../../../utils/validation/ValidationText";
import { getAuthProps } from "../../../utils/AuthenticationLibrary";
import { checkParameters, encryptAES } from "../../../utils/Encryption";
import CPASMemberServices from "../../../services/axiosServices/apiServices/CPASMemberServices";
import moment from "moment";
import TimePicker from "../../../components/TimePicker.js/TimePicker";
import TimeInput from "../../../components/inputs/TimeInput";
import SwalServices from "../../../services/swalServices/SwalServices";
import { Navigate } from "react-router-dom";
import { CommonSuccessMessages } from "../../../utils/Messages";
import Table from "../../../components/table/Table";
import { isLatLong } from "validator";
import { getAuditContext } from "../../../utils/audit/AuthenticationLibrary";

class AssignInterview extends Component {
  constructor(props) {
    super(props);
    this.CPASMemberServices = new CPASMemberServices();
    this.swalServices = new SwalServices();
    this.state = {
      timeGapError: "",
      isReadyToAssignInterview: false,
      assingIntBtnvalidationMessage: "",
      lastSequnceNo: null,
      latestSequnceNo: null,
      updatedBy: 0,
      cpasMemberid: 0,
      applicantsDataList: [],
      openInterviewModal: false,
      selectedApplicantsListForAssignInterview: [],
      selectAll: false,
      pagination: {
        pageNo: 1,
        pageSize: 10,
        orderByColumn: "",
        orderFlag: 0,
        statusId: 0,
        name: "",
        email: "",
        applicationTierId: 0,
        interviewDate: null,
        interviewTime: null,
      },
      assignInterviewDetails: [],
      commonInterviewDate: "",
    };
  }
  hasMinimumGap = (times, gapMinutes = 30) => {
    const minutesArray = times
      .map((t) => {
        const [h, m] = t.split(":").map(Number);
        return h * 60 + m;
      })
      .sort((a, b) => a - b);

    for (let i = 1; i < minutesArray.length; i++) {
      if (minutesArray[i] - minutesArray[i - 1] < gapMinutes) {
        return false;
      }
    }
    return true;
  };


  componentDidMount() {
    let cookie = getAuthProps();
    if (cookie != null) {
      const adminUserId = cookie.adminUserId;
      const adminname = cookie.name;
      this.setState({
        updatedBy: adminUserId,
        updatedAppId: 111,
        adminName: adminname,
      });
    }

    this.GetCpasInterviewApplicantList();
  }

  handleCommonDateChange = (e) => {
    this.setState({
      commonInterviewDate: e.target.value,
    });
  };

  // Handle single checkbox
  handleCheckboxChange = (index) => {
    const newData = [...this.state.applicantsDataList];
    // Toggle checkbox on current page row
    newData[index].selected = !newData[index].selected;
    const currentItem = newData[index];

    // update global selected map so selections persist across pages
    const selectedMap = { ...(this.state.selectedMap || {}) };
    const id = currentItem.cpasMemberId;
    if (currentItem.selected) {
      selectedMap[id] = currentItem;
    } else {
      delete selectedMap[id];
    }

    const selectedList = Object.values(selectedMap);

    // Validation
    let isReady = false;
    let message = "";
    if (selectedList.length === 3) {
      isReady = true;
    } else if (selectedList.length > 3) {
      message = "You cannot select more than 3 at a time.";
    } else {
      message = "Please select 3 applicants to continue.";
    }

    this.setState({
      applicantsDataList: newData,
      selectedApplicantsListForAssignInterview: selectedList,
      selectedMap: selectedMap,
      selectAll: newData.every((item) => item.selected),
      isReadyToAssignInterview: isReady,
      assingIntBtnvalidationMessage: message,
    });
  };

  // Handle select all
  handleSelectAll = () => {
    const { applicantsDataList, selectAll } = this.state;
    const newSelect = !selectAll;

    // Update the rows on current page
    const newData = applicantsDataList.map((item) => ({
      ...item,
      selected: newSelect,
    }));

    // Merge with global selected map
    const selectedMap = { ...(this.state.selectedMap || {}) };
    newData.forEach((row) => {
      const id = row.cpasMemberId;
      if (newSelect) selectedMap[id] = row;
      else delete selectedMap[id];
    });

    const selectedList = Object.values(selectedMap);

    // Validation
    let isReady = false;
    let message = "";
    if (selectedList.length === 3) {
      isReady = true;
    } else if (selectedList.length > 3) {
      message = "You cannot select more than 3 at a time.";
    } else {
      message = "Please select 3 applicants to continue.";
    }

    this.setState({
      applicantsDataList: newData,
      selectAll: newSelect,
      selectedApplicantsListForAssignInterview: selectedList,
      selectedMap: selectedMap,
      isReadyToAssignInterview: isReady,
      assingIntBtnvalidationMessage: message,
    });
  };

  GetCpasInterviewApplicantList = (pagination = this.state.pagination) => {
    this.setState({ isLoading: true });

    this.CPASMemberServices.GetCpasInterviewApplicantList(pagination).then((response) => {

      if (response.statusCode === 200 && response.responseItem != null) {
       
        
        let lastSequnceNo = response.responseItem.responseContent.itemList?.[0]?.latestBatchSN ?? 0;
        // ensure each row has a `selected` flag by checking global selectedMap
        const currentSelectedMap = this.state.selectedMap || {};
        let data = (response.responseItem.responseContent.itemList || []).map((item) => ({
          ...item,
          selected: !!currentSelectedMap[item.cpasMemberId],
          
        }));
        const selectedList = Object.values(currentSelectedMap);
        this.setState({
          applicantsDataList: data,
          lastSequnceNo: lastSequnceNo,
          totalResultes: response.responseItem.responseContent.totalCount,
          // keep selectedMap but update page select state and selected list
          selectAll: data.length > 0 && data.every((item) => item.selected),
          selectedApplicantsListForAssignInterview: selectedList,
        });
      }
    });
    this.setState({ isLoading: false });
  };
  // Add this helper to your class
  handleFilterChange = (e) => {
    const { name, value } = e.target;

    this.setState(prevState => ({
      pagination: {
        ...prevState.pagination,
        [name]: value,
        pageNo: 1 // Reset to first page on filter change
      }
    }), () => {
      // This callback runs AFTER state is updated
      this.GetCpasInterviewApplicantList();
    });
  };
  setOpenInterviewModal = (flag) => {
    this.setState({ openInterviewModal: flag });
  };

  handleChangeForTime = (value, field) => {
    this.setState((prevState) => ({
      assignInterviewDetails: {
        ...prevState.assignInterviewDetails,
        [field]: value,
      },
    }));
    let data = this.state.assignInterviewDetails;
  };

  // handleChange = (event, section) => {
  //   const name = event.target.name;
  //   const rawValue = event.target.value;
  //   const value = rawValue;
  //   this.setState((prev) => ({
  //     assignInterviewDetails: {
  //       ...prev.assignInterviewDetails,
  //       [ name ]: value,
  //     },
  //   }));
  // };
  GetAllDropDownsForCPASMember = () => {

    this.CPASMemberServices.GetAllDropDownsForCPASMember().then((response) => {
      if (response.statusCode === 200 && response.responseItem != null) {

        var status = response.responseItem.responseContent.filter((drp) => drp.dropdownName === "Status");
        status.map(function (item) { delete item["dropdownName"]; return item; });
        this.setState({ statusList: status });

        let TierList = response.responseItem.responseContent.filter((drp) => drp.dropdownName === "Tier");
        TierList.map(function (item) { delete item["dropdownName"]; return item; });
        // TierList = TierList.map((p) => ({ value: p.id, label: p.name }));
        this.setState({ applicationTierList: TierList });


      }
    });
    this.GetCpasInterviewApplicantList();
  }


  searchBySubmissionDate = () => {
    this.GetCpasInterviewApplicantList(this.state.pagination);
  }

  handleChange = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    let detail = this.state.pagination;
    detail[name] = value;
    this.setState({ pagination: detail });
  }

  AssignCPASInterview = () => {
    const audit = getAuditContext()

    this.setState({ timeGapError: "" });
    if (!this.state.commonInterviewDate) {
      this.setState({ timeGapError: "Please select interview date" });
      return;
    }

    const applicants = this.state.selectedApplicantsListForAssignInterview.map(
      (item, index) => ({
        cpasMemberId: item.cpasMemberId,
        interviewTime: this.state.assignInterviewDetails[index]?.interviewTime || null,
      })
    );

    // Time required check
    if (applicants.some((x) => !x.interviewTime)) {
      this.setState({
        timeGapError: "Please select interview time for all applicants",
      });
      return;
    }

    // ⏱️ 30-minute gap check
    const interviewTimes = applicants.map((a) => a.interviewTime);

    if (!this.hasMinimumGap(interviewTimes, 30)) {
      this.setState({
        timeGapError:
          "Each interview must have at least a 30-minute gap between times",
      });
      return;
    }

    let batchNo = this.state.lastSequnceNo + 1;

    const request = {
      interviewDate: this.state.commonInterviewDate,
      batchSN: batchNo,
      createdBy: audit.adminUserId,
      createdAppId: audit.appId,

      interviewStatusId: 1,
      applicants: applicants.map((a) => ({
        ...a,
        interviewTime: a.interviewTime + ":00",
      })),
    };
    this.swalServices.Confirm(
      CommonSuccessMessages.Confirm_AddText.replace("{0}", "record"),
      CommonSuccessMessages.Confirm_Submit.replace("{0}", "record"),
      CommonSuccessMessages.Yes_Text,
      CommonSuccessMessages.No_Text
    ).then((response) => {
      if (response) {

        this.CPASMemberServices.AssignCPASInterview(request).then((response) => {
          if (response.statusCode === 200) {
            this.swalServices.Success("Interview Scheduled").then(() => {
              window.location.reload();
            });
            this.GetCpasInterviewApplicantList();
            //  this.swalServices.Success("Interview Scheduled");

            this.setState({
              openInterviewModal: false,
              selectedApplicantsListForAssignInterview: [],
              assignInterviewDetails: [],
              commonInterviewDate: "",
              timeGapError: "",
            });
          } else {
            this.swalServices.Error(response.message);
          }
        });
      }
    });

  };


  openInterviewModalHandler = () => {
    const count = this.state.selectedApplicantsListForAssignInterview.length;

    if (count < 3) {
      alert("Please select exactly 3 applicants.");
      return;
    }
  };

  handleMultiChange = (value, index, field) => {
    let data = [...this.state.assignInterviewDetails];

    if (!data[index]) {
      data[index] = {};
    }

    data[index][field] = value.target ? value.target.value : value;

    this.setState({
      assignInterviewDetails: data,
    });
  };

  openInterviewPackage = (batchSN) => {

    if (batchSN && batchSN > 0) {
      this.setState({
        route:
          "/CpasInterview/batchSN?=" + encryptAES(batchSN),
      });
    }

  }
  searchByEmail = (value, identity) => {
    let detail = this.state.pagination;
    if (identity === "Email") {
      detail.pageNo = 1;
      detail.pageSize = 10;
      detail.email = value;
      this.setState({ pagination: { ...detail } });
    }
    this.GetCpasInterviewApplicantList();
  }
  searchByName = (value, identity) => {
    let detail = this.state.pagination;
    if (identity === "Name") {
      detail.pageNo = 1;
      detail.pageSize = 10;
      detail.name = value;
      this.setState({ pagination: { ...detail } });
    }
    this.GetCpasInterviewApplicantList();
  }
  setPagination = (newPagination) => {
    this.setState({ pagination: newPagination });
    this.GetCpasInterviewApplicantList();
  };


  render() {
    const { applicantsDataList, selectAll } = this.state;
    if (this.state.route != null) {
      return <Navigate to={this.state.route} />;
    }
    // Check if exactly 3 applicants selected
    const isThreeSelected = this.state.selectedApplicantsListForAssignInterview.length === 3;

    // Check if any selected applicant already has interview date or time
    const isAlreadyAssigned = this.state.selectedApplicantsListForAssignInterview.some(
      (applicant, index) =>
        applicant.interviewDate || this.state.assignInterviewDetails[index]?.interviewTime
    );

    // Final button disabled flag
    const isAssignInterviewDisabled =
      !isThreeSelected ||
      this.state.selectedApplicantsListForAssignInterview.some(
        (applicant, index) =>
          applicant.interviewDate ||
          this.state.assignInterviewDetails[index]?.interviewTime
      );

    return (
      <div>
        <div className="main-body-section">
          <div className="flex">
            <div className="relative flex flex-col flex-1 "></div>
          </div>

          <main className="pb-10">
            {/* Application Details */}
            <div className="mb-10">
              <div className="filter-info grid grid-cols-12 lg:gap-6 md:gap-6 gap-6 bg-white px-8 pt-10 pb-12">
                <div className="col-span-12 mb-4">
                  <div className="form-info-title">
                    <h4 className="text-[#2d2d2d] small-title font-bold theme-color">
                      Application Details
                    </h4>
                  </div>
                </div>

                {/* Application Name */}
                <div className="filter-types 2xl:col-span-5 lg:col-span-6 col-span-12">
                  <h2 className="input-title mb-3">
                    Application Name <span className="text-[#C00000]">*</span>
                  </h2>

                  <input
                    id="default"
                    className="form-input rounded-none w-full shadow-red py-3 text-lg"
                    type="text"
                    placeholder="Search"
                    onChange={(e) => this.searchByName(e.target.value, 'Name')}
                  />
                </div>

                {/* Interview Date */}
                <div className="lg:col-span-6 xl:col-span-3 col-span-12">
                  <h2 className="input-title mb-3">
                    Interview Date
                  </h2>

                  <div className="dropdown">

                    <input
                      type="date"
                      name="interviewDate" // Ensure name matches pagination state key
                      className="p-3 w-full border border-black"
                      value={this.state.pagination.interviewDate || ""}
                      onChange={this.handleFilterChange}
                    />
                  </div>
                </div>

                {/* Interview Time */}
                <div className="filter-types 2xl:col-span-3 lg:col-span-6 col-span-12">
                  <h2 className="input-title mb-3">
                    Interview Time
                  </h2>

                  <input
                    type="time"
                    name="interviewTime" // Ensure name matches pagination state key
                    className="form-input rounded-none w-full shadow-red py-3 text-lg"
                    value={this.state.pagination.interviewTime || ""}
                    onChange={this.handleFilterChange}
                  />
                </div>

                {/* Email */}
                <div className="filter-types 2xl:col-span-5 lg:col-span-6 col-span-12">
                  <h2 className="input-title mb-3">
                    Email Address
                  </h2>
                  <input
                    id="default"
                    className="form-input rounded-none w-full shadow-red py-3 text-lg"
                    type="text"
                    placeholder="Search"
                    onChange={(e) => this.searchByEmail(e.target.value, 'Email')}
                  />

                </div>
                <button
                  className="btn btn-blue text-white font-semibold mt-auto"
                  onClick={() => this.searchBySubmissionDate()}
                >
                  <span className="text-xl text-white font-semibold tracking-normal">
                    Search
                  </span>
                </button>
              </div>
            </div>

            {/* Table */}
            <div className="relative">
              <div onMouseLeave={() => this.onClose && this.onClose()}>
                <div className="flex flex-row-reverse items-center m-4">
                  {!isAssignInterviewDisabled && (
                    <button
                      className="bg-[#1c248b] hover:bg-[#1c238bd5] text-white font-bold py-4 px-6 text-2xl"
                      onClick={() => this.setOpenInterviewModal(true)}
                    >
                      Assign Interview
                    </button>
                  )}

                  {isAssignInterviewDisabled && (
                    <ValidationText
                      error={this.state.assingIntBtnvalidationMessage}
                    />
                  )}
                </div>
                <Table
                  columns={[
                    {
                      name: "selected",
                      title: (
                        <input
                          type="checkbox"
                          className="form-checkbox min-h-5 min-w-5"
                          checked={this.state.selectAll}
                          onChange={this.handleSelectAll}
                        />
                      ),
                    },
                    { name: "name", title: "Name" },
                    { name: "email", title: "Email" },
                    { name: "applicationTierName", title: "Tier" },
                    { name: "submissionDate", title: "Submission Date" },
                    { name: "interviewDate", title: "Interview Date" },
                    { name: "interviewTime", title: "Interview Time" },
                    { name: "batchSN", title: "Batch SN" },
                    { name: "actions", title: "Actions" },
                  ]}
                  rows={this.state.applicantsDataList}
                  isLoading={this.state.isLoading}
                  pagination={this.state.pagination}
                  sortingColumns={["applicationTierName", "submissionDate"]}
                  totalResultes={this.state.totalResultes}
                  totalCount={this.state.totalResultes}
                  setPagination={this.setPagination}
                  customScope={[
                    {
                      column: "selected",
                      renderTableData: (element, index, value) => (
                        <td className="px-2 first:pl-5 last:pr-5 whitespace-nowrap tble-td-txt text-[#000000]">
                          <input
                            type="checkbox"
                            className="form-checkbox min-h-5 min-w-5"
                            checked={value || false}
                            onChange={() => this.handleCheckboxChange(index)}
                          />
                        </td>
                      ),
                    },
                    {
                      column: "submissionDate",
                      renderTableData: (element, index, value) => (
                        <td className="px-2 first:pl-5 last:pr-5 whitespace-nowrap tble-td-txt text-[#000000]">
                          {value
                            ? moment(value).format("DD MMM YYYY")
                            : "-"}
                        </td>
                      ),
                    },
                    {
                      column: "interviewDate",
                      renderTableData: (element, index, value) => (
                        <td className="px-2 first:pl-5 last:pr-5 whitespace-nowrap tble-td-txt text-[#000000]">
                          {value
                            ? new Date(value).toLocaleDateString("en-GB")
                            : "-"}
                        </td>
                      ),
                    },
                    {
                      column: "batchSN",
                      renderTableData: (element, index, value) => (
                        <td className="px-2 first:pl-5 last:pr-5 whitespace-nowrap tble-td-txt text-[#000000]">
                          {value && value > 0 ? value : "-"}
                        </td>
                      ),
                    },
                    {
                      column: "actions",
                      renderTableData: (element, index, value) => {
                        const batch = this.state.applicantsDataList[index]?.batchSN;
                        return (
                          <td className="px-2 first:pl-5 last:pr-5 whitespace-nowrap tble-td-txt text-[#000000]">
                            {batch && batch > 0 ? (
                              <a
                                href="#"
                                className="text-blue-600 underline cursor-pointer"
                                onClick={(e) => {
                                  e.preventDefault();
                                  this.openInterviewPackage(batch);
                                }}
                              >
                                View
                              </a>
                            ) : (
                              ""
                            )}
                          </td>
                        );
                      },
                    },
                  ]}
                />
              </div>



              {this.state.openInterviewModal && (
                <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
                  <div className="bg-white w-[95%] max-w-6xl rounded-lg shadow-lg p-6 relative max-h-[90vh] overflow-y-auto">
                    {/* HEADER */}
                    <div className="flex justify-between items-center mb-6">
                      <h3 className="text-lg font-semibold">
                        Assign Interview (
                        {
                          this.state.selectedApplicantsListForAssignInterview
                            .length
                        }
                        )
                      </h3>

                      <button
                        className="text-xl"
                        onClick={() => this.setOpenInterviewModal(false)}
                      >
                        ✕
                      </button>
                    </div>

                    {/* ================= FORM BODY ================= */}
                    {/* ================= FORM BODY ================= */}

                    {/* ================= COMMON DATE ================= */}

                    <div className="grid grid-cols-12 gap-4 mb-6">
                      <div className="col-span-12 common-interview-date">
                        <h2 className="input-title mb-2">
                          Interview Date{" "}
                          <span className="text-[#C00000]"> *</span>
                        </h2>

                        <input
                          type="date"
                          className="p-3 w-full border border-black rounded"
                          value={this.state.commonInterviewDate}
                          onChange={this.handleCommonDateChange}
                        />
                      </div>
                    </div>

                    {/* ================= APPLICANTS ================= */}
                    <div className="applicant-detail-time-wrapper ">
                      {this.state.selectedApplicantsListForAssignInterview.map(
                        (item, index) => (
                          <div key={index} className="applicant-detail-time">
                            {/* Applicant Name */}
                            <div className="applicant-detail">
                              <div className="title">Applicant {index + 1}</div>

                            </div>
                            <div className="applicant-name">{item.name}</div>
                            {/* Interview Time */}
                            <div className="col-span-12 ">
                              <h2 className="input-title mb-2">
                                Interview Time{" "}
                                <span className="text-[#C00000]"> *</span>
                              </h2>

                              <input
                                type="time"
                                className="custom-time-picker"
                                value={
                                  this.state.assignInterviewDetails[index]
                                    ?.interviewTime || ""
                                }
                                onChange={(e) =>
                                  this.handleMultiChange(
                                    e.target.value,
                                    index,
                                    "interviewTime"
                                  )
                                }
                              />
                              {this.state.timeGapError && (
                                <div className="text-[#C00000] text-sm mt-3">
                                  {this.state.timeGapError}
                                </div>
                              )}
                            </div>
                          </div>
                        )
                      )}
                    </div>

                    {/* FOOTER */}
                    <div className="flex justify-end gap-4 mt-8">
                      <button
                        className="btn btn-border-caps"
                        onClick={() => this.setOpenInterviewModal(false)}
                      >
                        Cancel
                      </button>
                      <button
                        className="btn btn-caps"
                        onClick={() => {
                          // this.handleAddRemoveDataList("HandleAdd", "EmploymentHistory");
                          this.AssignCPASInterview();
                        }}
                      >
                        Schedule Interview
                      </button>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </main>
        </div>
      </div>
    );
  }
}

export default AssignInterview;
